import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=4af0aa13&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=4af0aa13&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0aa13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af0aa13')) {
      api.createRecord('4af0aa13', component.options)
    } else {
      api.reload('4af0aa13', component.options)
    }
    module.hot.accept("./BaseButton.vue?vue&type=template&id=4af0aa13&scoped=true", function () {
      api.rerender('4af0aa13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseButton.vue"
export default component.exports